import {
  Basket,
  BasketItem,
  KnownBasketItemPaymentMethodType,
} from '../client/src';
import {
  ITicketDescriptionFields,
  IBasketItemWithDescription,
  IBasketWithDescriptions,
} from '@nx-ng/types';
import { orderBy } from 'lodash-es';

export const combineBasketItemsWithDescriptions = (
  basketItems?: BasketItem[],
  ticketDescriptions?: ITicketDescriptionFields
): IBasketItemWithDescription[] => {
  if (!basketItems) {
    return [];
  }

  return basketItems?.map((item: BasketItem): IBasketItemWithDescription => {
    const ticket = ticketDescriptions?.[item.ticketID];

    const title = ticket?.title || '';
    const description = ticket?.description || '';
    const ticketType = ticket?.ticketType || '';
    const alias = ticket?.alias || '';
    const subtitle = `${alias}-subtitle`;
    const paymentMethodType =
      (item?.paymentMethodType as KnownBasketItemPaymentMethodType) ||
      KnownBasketItemPaymentMethodType.OneOff;

    const isDirectDebit = ticket?.isDirectDebit || false;
    const termDateFrom = ticket?.termDateFrom || '';
    const termDateTo = ticket?.termDateTo || '';

    return {
      ...item,
      ticketType,
      description,
      paymentMethodType,
      isDirectDebit,
      title,
      subtitle,
      alias,
      termDateFrom,
      termDateTo,
    };
  });
};

export const combineBasketTicketsWithDescription = (
  basket?: Basket,
  ticketDescriptions?: ITicketDescriptionFields
): IBasketWithDescriptions | undefined => {
  if (!basket) {
    return undefined;
  }
  const basketItems = combineBasketItemsWithDescriptions(
    basket.basketItems,
    ticketDescriptions
  );

  const directDebitItems = orderBy(
    basketItems.filter(
      (item: IBasketItemWithDescription) => item.isDirectDebit
    ),
    (item: IBasketItemWithDescription) => item.subTotalPrice,
    'asc'
  );

  return {
    ...basket,
    basketItems: [
      ...directDebitItems,
      ...basketItems.filter(
        (item: IBasketItemWithDescription) => !item.isDirectDebit
      ),
    ],
  };
};
